import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { SmartLinkEditionView } from '../../modules/smartLinks/smartLinkEditionView/SmartLinkEditionView';
import { SmartLinkManageView } from '../../modules/smartLinks/smartLinkManageView/SmartLinkManageView';
import { SmartLinkDetailsView } from '../../modules/smartLinks/smartLinkDetailsView/SmartLinkDetailsView';
import { WidgetEditionView } from '../../modules/smartLinks/widgets/views/widgetEditionView/WidgetEditionView';
import { SmartLinksMainView } from '../../modules/smartLinks/smlHomeView/SmartLinksMainView';
import { SMLAuthView } from '../../modules/smartLinks/smlAuth/SMLAuthView';
import { AllSmartLinksRedirect } from '../../modules/smartLinks/smlHomeView/AllSmartLinksRedirect';
import { LEGACY_ALL_SMARTLINKS_PATH } from '../../modules/smartLinks/smlHomeView/smartLinksOverviewQuery';
import { SMLSettingsView } from '../../modules/settings/views/SMLSettingsView';
import { SMLDebugView } from '../../modules/music24/debug/SMLDebugView';
import { SMLRouteNames } from './SMLRoutes';
import { ReleaseLinkWizardView } from '../../modules/smartLinks/wizards/releaseLink/ReleaseLinkWizardView';
import { PresaveCreateView } from '../../modules/smartLinks/presaveCreate/PresaveCreateView';
import { SMLDuplicationView } from '../../modules/smartLinks/smlDuplicateView/SMLDuplicationView';
import { PlaylistLinkWizardView } from '../../modules/smartLinks/wizards/playlistLink/PlaylistLinkWizardView';
import { PrivateOnlyRouteController } from '../../modules/smartLinks/authRouteControllers/PrivateOnlyRouteController';
import { PrivateOrSharedTokenRouteController } from '../../modules/smartLinks/authRouteControllers/PrivateOrSharedTokenRouteController';
import { PublicOnlyRouteController } from '../../modules/smartLinks/authRouteControllers/PublicOnlyRouteController';
import { SMLFormModalRouter } from './SMLFormModalRouter';
import { SMLWatchlistView } from '../../modules/music24/watchlist/SMLWatchlistView';
import { ArtistHomeView } from '../../modules/music24/artistHome/ArtistHomeView';
import { SMLTrendsView } from '../../modules/music24/SMLTrendsView';
import { SMLMarketsView } from '../../modules/music24/markets/SMLMarketsView';
import { SMLArtistsHome } from '../../modules/music24/SMLArtistsHome';
import { SMLArtistDetails } from '../../modules/music24/SMLArtistDetails';
import { SMLTracksHome } from '../../modules/music24/SMLTracksHome';
import { SMLTrackDetails } from '../../modules/music24/SMLTrackDetails';
import { SMLPlaylistsHome } from '../../modules/music24/SMLPlaylistsHome';
import { SMLPlaylistDetails } from '../../modules/music24/SMLPlaylistDetails';
import { SMLBrowseHome } from '../../modules/music24/SMLBrowseHome';
import { CatalogView } from '../../modules/smartLinks/catalog/CatalogView';
import { SoundCloudReturnView } from '../../modules/smartLinks/catalog/soundCloud/SoundCloudReturnView';
import { CatalogLyricsRedirect, CatalogSongView } from '../../modules/smartLinks/catalog/song/page/CatalogSongView';
import { StreamingView } from '../../modules/music24/streaming/StreamingView';
import { SMLPublicShareView } from '../../modules/music24/SMLPublicShareView';
import { AssetShareView } from '../../modules/music24/assetShare/AssetShareView';
import { CoverEditorView } from '../../modules/coverEditor/CoverEditorView';
import { COVER_EDITOR_SEGMENT } from '../../modules/coverEditor/coverEditorPath';
import { CoverCarryView } from '../../modules/coverEditor/carry/CoverCarryView';
import { MusicVideoEditorView } from '../../modules/musicVideoEditor/MusicVideoEditorView';
import { MUSIC_VIDEO_EDITOR_SEGMENT } from '../../modules/musicVideoEditor/musicVideoEditorPath';
import { DirectedVideoView } from '../../modules/directedVideo/DirectedVideoView';
import { DIRECTED_VIDEO_SEGMENT } from '../../modules/directedVideo/directedVideoPath';
import { PublicCoverMakerView } from '../../modules/coverEditor/publicMode/PublicCoverMakerView';
import { COVER_CARRY_SEGMENT, COVER_MAKER_SEGMENT } from '../../modules/coverEditor/publicMode/publicCoverPath';
import { MUSIC_VIDEO_DEMO_SEGMENT } from '../../modules/musicVideoEditor/showcase/musicVideoDemoPath';
import { MusicVideoShowcaseView } from '../../modules/musicVideoEditor/showcase/MusicVideoShowcaseView';
import { PaymentCompleteView } from '../../modules/music24/paymentCompleteView/PaymentCompleteView';
import { SMLRootRedirect } from './SMLRootRedirect';
import { SettingsPathTabRedirect, SettingsTabRedirect } from './SettingsTabRedirect';
import { ReleasesListScreen } from '../../modules/music24/promote/releases/ReleasesListScreen';
import { ReleasePageScreen } from '../../modules/music24/promote/releases/ReleasePageScreen';
import { PromoteCalendarView } from '../../modules/music24/promote/calendar/PromoteCalendarView';
import { PromoteChannelsView } from '../../modules/music24/promote/channels/PromoteChannelsView';
import { PromoteLibraryRedirect } from '../../modules/music24/promote/PromoteLibraryRedirect';
import { PromoteLegacyRedirect } from '../../modules/music24/promote/PromoteLegacyRedirect';
import { StudioView } from '../../modules/music24/promote/studio/StudioView';
import { ProfileView } from '../../modules/music24/promote/profile/ProfileView';
import { PromoteFilesRedirect } from '../../modules/music24/promote/PromoteFilesRedirect';
import { WorkLinkRedirect } from '../../modules/music24/promote/work/WorkLinkRedirect';
import { PostsView } from '../../modules/music24/promote/posts/PostsView';
import { PromoteComposerView } from '../../modules/music24/promote/composer/PromoteComposerView';
import { SocialView } from '../../modules/music24/social/SocialView';
import { FansView } from '../../modules/music24/fans/FansView';
import { PlansView } from '../../modules/music24/plans/PlansView';
import { ReviewView } from '../../modules/music24/review/ReviewView';
import { InsightsConnectRedirect, InsightsRedirect, PerformanceRedirect } from './IntelligenceLegacyRedirects';
import { OAuthConsentView } from '../../modules/music24/oauthConsentView/OAuthConsentView';
import { TeamAcceptView } from '../../modules/team/TeamAcceptView';
import { GetAppView } from '../../modules/mobileApps/GetAppView';
import { WelcomeWithTour } from '../../modules/onboarding/tour/WelcomeWithTour';
import { CatalogAddSongView } from '../../modules/smartLinks/catalog/addSong/CatalogAddSongView';
import { OutreachRoutes } from '../../modules/music24/outreach/OutreachRoutes';
import { NotFoundView } from '../../modules/app/notFound/NotFoundView';

export const SMLAppNavigationRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SMLRootRedirect />} />
      {/* Not a typed SMLRouteNames entry (like "/" above): this is a plain landing
          page reached only by `/oauth/authorize`'s external 302, never by
          `useSMLRouter().push`. The literal path must match that redirect
          target exactly (server/src/app/components/OAuth/OAuth.controller.ts). */}
      <Route
        path="oauth-consent"
        element={
          <PrivateOnlyRouteController>
            <OAuthConsentView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Plain path like oauth-consent: reached only from the invite email link
          ({SMARTLINKS_APP_URL}/team/accept#token=…, music24-api SendTeamInviteEmailJob).
          No PrivateOnlyRouteController: the view redirects to sign-in itself and keeps the
          token across the round trip (see teamInviteToken.ts). */}
      <Route path="team/accept" element={<TeamAcceptView />} />
      {/* Plain public path: the mobile-app handoff link (QR code, email). It sends a phone to its
          store and any other browser to `next`. Contract:
          docs/superpowers/plans/2026-09-29-music24-mobile-app-handoff.md. */}
      <Route path="get" element={<GetAppView />} />
      {/* The welcome page (design: onboarding a1-a8). A full page like the sign-in page: no
          SMLContainer, so no sidebar. */}
      <Route
        path={SMLRouteNames.welcome}
        element={
          <PrivateOnlyRouteController>
            <WelcomeWithTour />
          </PrivateOnlyRouteController>
        }
      />
      {/* "Add my song": the steps of the Catalog "Add a song" page with the onboarding Done
          (design catalog-add-song f4). A full page with no sidebar. */}
      <Route
        path={SMLRouteNames.addSong}
        element={
          <PrivateOnlyRouteController>
            <CatalogAddSongView context="onboarding" />
          </PrivateOnlyRouteController>
        }
      />
      {/* The pre-save link of a song (design presave-create). A full page with no sidebar, like Add my
          song. The address stays /smartlinks/presaveLink: every entry point and old link uses it. */}
      <Route
        path={`${SMLRouteNames.smartlinks}/${SMLRouteNames.presaveLink}`}
        element={
          <PrivateOnlyRouteController>
            <PresaveCreateView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.home}
        element={
          <PrivateOnlyRouteController>
            <ArtistHomeView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.watchlist}
        element={
          <PrivateOnlyRouteController>
            <SMLWatchlistView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.trends}
        element={
          <PrivateOnlyRouteController>
            <SMLTrendsView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.markets}
        element={
          <PrivateOnlyRouteController>
            <SMLMarketsView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.artists}
        element={
          <PrivateOnlyRouteController>
            <SMLArtistsHome />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.artists}/${SMLRouteNames.artistDetails}`}
        element={
          <PrivateOrSharedTokenRouteController>
            <SMLArtistDetails />
          </PrivateOrSharedTokenRouteController>
        }
      />
      <Route
        path={SMLRouteNames.tracks}
        element={
          <PrivateOnlyRouteController>
            <SMLTracksHome />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.tracks}/${SMLRouteNames.trackDetails}`}
        element={
          <PrivateOrSharedTokenRouteController>
            <SMLTrackDetails />
          </PrivateOrSharedTokenRouteController>
        }
      />
      <Route
        path={SMLRouteNames.playlists}
        element={
          <PrivateOnlyRouteController>
            <SMLPlaylistsHome />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.playlists}/${SMLRouteNames.playlistDetails}`}
        element={
          <PrivateOrSharedTokenRouteController>
            <SMLPlaylistDetails />
          </PrivateOrSharedTokenRouteController>
        }
      />
      <Route
        path={SMLRouteNames.browse}
        element={
          <PrivateOnlyRouteController>
            <SMLBrowseHome />
          </PrivateOnlyRouteController>
        }
      />
      {/* Your intelligence → Streaming (design your-intelligence h4). Each section is a path; the
          old Insights links redirect here and keep their query. */}
      <Route
        path={SMLRouteNames.streaming}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="overview" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/tracks`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="tracks" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/tracks/:trackId`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="track" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/stores`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="stores" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/countries`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="countries" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/audience`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="audience" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/playSources`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="playSources" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/shortVideo`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="shortVideo" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/accelerator`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="accelerator" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/playlists`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="playlists" />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.streaming}/earnings`}
        element={
          <PrivateOnlyRouteController>
            <StreamingView section="earnings" />
          </PrivateOnlyRouteController>
        }
      />
      <Route path="insights" element={<InsightsRedirect />} />
      <Route path="insights/connect/:service" element={<InsightsConnectRedirect />} />
      {/* Your intelligence → Social, the old Promote → Performance. */}
      <Route
        path={SMLRouteNames.social}
        element={
          <PrivateOnlyRouteController>
            <SocialView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.social}/post/:id`}
        element={
          <PrivateOnlyRouteController>
            <SocialView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Your intelligence → Fans: the fans who get every new release. */}
      <Route
        path={SMLRouteNames.fans}
        element={
          <PrivateOnlyRouteController>
            <FansView />
          </PrivateOnlyRouteController>
        }
      />
      {/* "Review MUSIC24" (design review-form a1-a10): the review form of the signed-in user. */}
      <Route
        path={SMLRouteNames.review}
        element={
          <PrivateOnlyRouteController>
            <ReviewView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The plans page (design plans-page a): a full page, not a modal. */}
      <Route
        path={SMLRouteNames.plans}
        element={
          <PrivateOnlyRouteController>
            <PlansView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Outreach (spec 2026-10-11 §6): Pitch, Your sound, Find, Contacts, campaigns, Inbox. */}
      <Route path={`${SMLRouteNames.outreach}/*`} element={<OutreachRoutes />} />
      <Route path={`${SMLRouteNames.promote}/promotePerformance`} element={<PerformanceRedirect />} />
      <Route
        path={SMLRouteNames.catalog}
        element={
          <PrivateOnlyRouteController>
            <CatalogView />
          </PrivateOnlyRouteController>
        }
      />
      {/* A connect link of the app (design your-intelligence h4): Catalog opens the connect of the
          service. On the web, Ditto Music and Spotify for Artists open the phone handoff. */}
      <Route
        path={`${SMLRouteNames.catalog}/connect/:service`}
        element={
          <PrivateOnlyRouteController>
            <CatalogView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The return page of the SoundCloud sign-in (design soundcloud-connector b): MusicAPI sends the
          browser to `connect/soundCloud?state=…`. A static segment wins over `:service`. */}
      <Route
        path={`${SMLRouteNames.catalog}/connect/soundCloud`}
        element={
          <PrivateOnlyRouteController>
            <SoundCloudReturnView />
          </PrivateOnlyRouteController>
        }
      />
      {/* "Add a song", one step at a time (design catalog-add-song): a full page with no sidebar. */}
      <Route
        path={`${SMLRouteNames.catalog}/new`}
        element={
          <PrivateOnlyRouteController>
            <CatalogAddSongView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The song page of one catalog row (design song-page). */}
      <Route
        path={`${SMLRouteNames.catalog}/song/:catalogItemUuid`}
        element={
          <PrivateOnlyRouteController>
            <CatalogSongView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The cover editor of one song (design cover-editor b1): full screen, with no app sidebar. */}
      <Route
        path={`${SMLRouteNames.catalog}/song/:catalogItemUuid/${COVER_EDITOR_SEGMENT}`}
        element={
          <PrivateOnlyRouteController>
            <CoverEditorView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The music video editor of one song (design music-video b1): full screen, with no app sidebar. */}
      <Route
        path={`${SMLRouteNames.catalog}/song/:catalogItemUuid/${MUSIC_VIDEO_EDITOR_SEGMENT}`}
        element={
          <PrivateOnlyRouteController>
            <MusicVideoEditorView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The directed video wizard of one song (design directed-video b1): full screen, with no app
          sidebar. The video uuid is in the path, so reload and Back work; with none it opens or makes one. */}
      <Route
        path={`${SMLRouteNames.catalog}/song/:catalogItemUuid/${DIRECTED_VIDEO_SEGMENT}/:directedVideoUuid?`}
        element={
          <PrivateOnlyRouteController>
            <DirectedVideoView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The old lyric editor page: shipped native apps and old links go to the Lyrics section. */}
      <Route
        path={`${SMLRouteNames.catalog}/${SMLRouteNames.catalogLyrics}`}
        element={
          <PrivateOnlyRouteController>
            <CatalogLyricsRedirect />
          </PrivateOnlyRouteController>
        }
      />
      {/* Promote: one pillar, sibling routes. The shared shell lives in each screen so a page
          keeps its own page head, and every page is a url. `promote` is the Releases list. */}
      <Route
        path={SMLRouteNames.promote}
        element={
          <PrivateOnlyRouteController>
            <ReleasesListScreen />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteRelease}`}
        element={
          <PrivateOnlyRouteController>
            <ReleasePageScreen />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteCalendar}`}
        element={
          <PrivateOnlyRouteController>
            <PromoteCalendarView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteChannels}`}
        element={
          <PrivateOnlyRouteController>
            <PromoteChannelsView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Plain paths: the Clip Studio and Reel Studio are gone (spec D24, D28). An old link or
          bookmark opens the Studio; a Reel Studio link opens its AI reel theme. */}
      <Route path={`${SMLRouteNames.promote}/promoteClips`} element={<PromoteLegacyRedirect from="clips" />} />
      <Route path={`${SMLRouteNames.promote}/promoteReels`} element={<PromoteLegacyRedirect from="reels" />} />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteStudio}`}
        element={
          <PrivateOnlyRouteController>
            <StudioView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Studio → Profile (spec 2026-10-17 artist Profile): `?tool=` and `?sheet=` keep the view. */}
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteProfile}`}
        element={
          <PrivateOnlyRouteController>
            <ProfileView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Navigation v2 (design c 3e): Work is a panel on Studio. This route opens Studio with the
          panel open (`?work=1`). A link of a finished file (emails, pushes) still opens the file in
          its home first (`promote/work/workLinkTarget.ts`). */}
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteWork}`}
        element={
          <PrivateOnlyRouteController>
            <WorkLinkRedirect />
          </PrivateOnlyRouteController>
        }
      />
      {/* design: assets-rethink d1. Posts replaced Assets in the menu; an old Assets link opens the
          file in its home by its kind. */}
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteAssets}`}
        element={
          <PrivateOnlyRouteController>
            <PromoteFilesRedirect />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promotePosts}`}
        element={
          <PrivateOnlyRouteController>
            <PostsView />
          </PrivateOnlyRouteController>
        }
      />
      {/* Releases v2: the Library is gone; an old link opens the Releases list. */}
      <Route path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteLibrary}`} element={<PromoteLibraryRedirect />} />
      <Route
        path={`${SMLRouteNames.promote}/${SMLRouteNames.promoteComposer}`}
        element={
          <PrivateOnlyRouteController>
            <PromoteComposerView />
          </PrivateOnlyRouteController>
        }
      />
      <Route
        path={SMLRouteNames.smartlinks}
        element={
          <PrivateOnlyRouteController>
            <SMLFormModalRouter path={SMLRouteNames.smartlinks}>
              <Outlet />
            </SMLFormModalRouter>
            <SmartLinksMainView />
          </PrivateOnlyRouteController>
        }
      >
        <Route path={SMLRouteNames.create} element={<SmartLinkEditionView />} />
        <Route path={SMLRouteNames.releaseLink} element={<ReleaseLinkWizardView />} />
        <Route path={SMLRouteNames.playlistLink} element={<PlaylistLinkWizardView />} />
      </Route>
      <Route
        path={SMLRouteNames.auth}
        element={
          <PublicOnlyRouteController>
            <SMLAuthView />
          </PublicOnlyRouteController>
        }
      />
      {/* The old Edit Profile page: its parts live in Settings → Artist and Settings → SmartLinks. */}
      <Route path={SMLRouteNames.account} element={<SettingsTabRedirect tab="artist" />} />
      {/* The old full list of SmartLinks: the SmartLinks page shows every page now. */}
      <Route path={LEGACY_ALL_SMARTLINKS_PATH} element={<AllSmartLinksRedirect />} />
      <Route
        path={SMLRouteNames.manage}
        element={
          <PrivateOnlyRouteController>
            <SMLFormModalRouter path={SMLRouteNames.manage}>
              <Outlet />
            </SMLFormModalRouter>
            <SmartLinkManageView />
          </PrivateOnlyRouteController>
        }
      >
        <Route path={SMLRouteNames.duplicate} element={<SMLDuplicationView />} />
      </Route>
      <Route
        path={SMLRouteNames.details}
        element={
          <PrivateOnlyRouteController>
            {/* No SMLFormModalRouter here: the Creator hosts its child routes
                (theme, widget edit) in its own rail, not in a modal. */}
            <SmartLinkDetailsView />
          </PrivateOnlyRouteController>
        }
      >
        <Route path={SMLRouteNames.edit} element={<SmartLinkEditionView />} />
        <Route path={SMLRouteNames.widgetEdit} element={<WidgetEditionView />} />
      </Route>
      <Route
        path={SMLRouteNames.settings}
        element={
          <PrivateOnlyRouteController>
            <SMLSettingsView />
          </PrivateOnlyRouteController>
        }
      />
      {/* A tab written as a path (/app/settings/artist) opens the tab of the query. */}
      <Route path={`${SMLRouteNames.settings}/:tab/*`} element={<SettingsPathTabRedirect />} />
      <Route path={SMLRouteNames.debug} element={<SMLDebugView />} />
      <Route path={SMLRouteNames.paymentComplete} element={<PaymentCompleteView />} />
      <Route path={`${SMLRouteNames.public}/:code`} element={<SMLPublicShareView />} />
      {/* The share link of one made asset. Public: a member lands on the asset in its release, and
          anybody else sees the public view (no route controller). */}
      <Route path={`${SMLRouteNames.a}/:token`} element={<AssetShareView />} />
      {/* The public cover maker (design cover-editor g): no login, full screen. `?embed=1` is the
          tool inside music24.com/song-artwork-maker. */}
      <Route path={COVER_MAKER_SEGMENT} element={<PublicCoverMakerView />} />
      {/* After a sign-in with a design of the public tool: "Which song is this cover for?" (g4). */}
      <Route
        path={`${COVER_MAKER_SEGMENT}/${COVER_CARRY_SEGMENT}`}
        element={
          <PrivateOnlyRouteController>
            <CoverCarryView />
          </PrivateOnlyRouteController>
        }
      />
      {/* The Studio showcase (spec 2026-10-10, design studio-showcase c): the music video editor on the
          "Forests" cut, no login, for every visitor; nothing is saved. `?embed=1` is the demo inside
          music24.com/music-video-maker. */}
      <Route path={MUSIC_VIDEO_DEMO_SEGMENT} element={<MusicVideoShowcaseView />} />
      {/* The old Manage Trackers pages: the trackers live in Settings → SmartLinks. */}
      <Route path={`${SMLRouteNames.trackers}/*`} element={<SettingsTabRedirect tab="smartlinks" />} />
      {/* Every other address (QA finding brk-1): "Page not found" with a way out, signed in or not. */}
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};
